<template>
    <div>

        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="editLivro && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitLivro" v-if="!editLivro || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editLivro || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Capa" prop="capa" key="capa" class="u-text-center">
                            <input-image v-model="capaFile" :maxBytes="2097152" @erro="onCapaErro" @delete="onCapaDelete"></input-image>
                            <img v-if="!capaFile && capaUrl" :src="capaUrl" class="img-avatar" style="max-width:180px; margin: 8px auto; display:block;">
                            <small class="u-text-muted">PNG ou JPEG, até 2MB.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Título *" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                                    <el-input v-model="dados.titulo" maxlength="191" v-on:blur="formatData('titulo')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Ano" prop="ano_publicacao" key="ano_publicacao">
                                    <el-input v-model="dados.ano_publicacao" maxlength="4"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <!--
                                    O campo de TEXTO continua existindo e continua obrigatório:
                                    é o que o acervo legado tem, e nada foi apagado. A seleção
                                    do autor catalogado (item 10) fica ao lado, mais abaixo.
                                -->
                                <el-form-item label="Autor (texto) *" prop="autor" :rules="[$requiredBlur]" key="autor">
                                    <el-input v-model="dados.autor" maxlength="191" v-on:blur="formatData('autor')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Editora (texto)" prop="editora" key="editora">
                                    <el-input v-model="dados.editora" maxlength="191" v-on:blur="formatData('editora')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="ISBN" prop="isbn" key="isbn">
                            <el-input v-model="dados.isbn" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Edição" prop="edicao" key="edicao">
                            <el-input v-model="dados.edicao" maxlength="191" v-on:blur="formatData('edicao')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Categoria / assunto" prop="categoria" key="categoria">
                            <el-input v-model="dados.categoria" maxlength="191" v-on:blur="formatData('categoria')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <!--
                            Item 11: "disponibilizando as opções de obras literárias,
                            publicações periódicas e mídias digitais". A lista vem do backend
                            (`BibliotecaHelper::TIPOS_MATERIAL`) — uma só fonte.

                            Material antigo pode ter um tipo fora dessa lista; nesse caso ele
                            aparece marcado como legado e continua salvável, mas não é
                            oferecido para novos.
                        -->
                        <el-form-item label="Tipo do material" prop="tipo" key="tipo">
                            <el-select v-model="dados.tipo" placeholder="Selecione" clearable style="width:100%">
                                <el-option v-for="t in tiposMaterial" :key="t.valor"
                                           :label="t.rotulo" :value="t.valor"></el-option>
                                <el-option v-if="tipoLegado" :key="tipoLegado"
                                           :label="tipoLegado.toUpperCase() + ' (classificação antiga)'"
                                           :value="tipoLegado"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Classificação Dewey (CDD)" prop="cdd" key="cdd">
                            <el-input v-model="dados.cdd" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Número de tombo" prop="numero_tombo" key="numero_tombo">
                            <el-input v-model="dados.numero_tombo" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Quantidade de exemplares" prop="quantidade_exemplares" key="quantidade_exemplares">
                            <el-input v-model="dados.quantidade_exemplares" maxlength="6"></el-input>
                            <small v-if="editLivro" class="u-text-muted">Ao editar, aumentar a quantidade cria novos exemplares automaticamente.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Localização (estante/prateleira)" prop="localizacao" key="localizacao">
                            <el-input v-model="dados.localizacao" maxlength="191" v-on:blur="formatData('localizacao')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Idioma" prop="idioma" key="idioma">
                            <el-input v-model="dados.idioma" maxlength="191" v-on:blur="formatData('idioma')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Número de páginas" prop="numero_paginas" key="numero_paginas">
                            <el-input v-model="dados.numero_paginas" maxlength="6"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--
                    ==================== CATALOGAÇÃO — BLOCO X ====================

                    Itens 1 a 10 do edital. Todos OPCIONAIS: o material continua podendo ser
                    cadastrado só com os campos de texto, como sempre foi. Preencher aqui é o
                    que liga o acervo aos cadastros próprios.
                -->
                <el-divider content-position="left">Catalogação</el-divider>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Autor (cadastro)" key="autor_id">
                            <el-select v-model="dados.autor_id" placeholder="Selecione o autor" clearable
                                       filterable style="width:100%">
                                <el-option v-for="a in cat.autor" :key="a.id"
                                           :label="a.nome_apresentacao || a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Editora / produtora (cadastro)" key="editora_id">
                            <el-select v-model="dados.editora_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="e in cat.editora" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Idioma (cadastro)" key="idioma_id">
                            <el-select v-model="dados.idioma_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="i in cat.idioma" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Assunto (cadastro)" key="assunto_id">
                            <el-select v-model="dados.assunto_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="a in cat.assunto" :key="a.id"
                                           :label="'N' + a.nivel + ' — ' + a.descricao" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Coleção / série" key="colecao_id">
                            <el-select v-model="dados.colecao_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="c in cat.colecao" :key="c.id"
                                           :label="c.descricao + (c.tipo === 'serie' ? ' (série)' : ' (coleção)')"
                                           :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Volume" key="volume">
                            <el-input v-model="dados.volume" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <!-- A classificação em uso na rede aparece em destaque no rótulo. -->
                        <el-form-item :label="'Classificação' + (classificacaoPadrao ? ' — em uso: ' + classificacaoPadrao.toUpperCase() : '')"
                                      key="classificacao_id">
                            <el-select v-model="dados.classificacao_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="c in classificacoesOrdenadas" :key="c.id"
                                           :label="c.tipo.toUpperCase() + ' ' + c.codigo + ' — ' + c.descricao"
                                           :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Cutter" key="cutter_id">
                            <el-select v-model="dados.cutter_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="c in cat.cutter" :key="c.id"
                                           :label="c.codigo + ' — ' + c.descricao" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data de cadastro" key="data_cadastro">
                            <!-- Item 9 pede "data de cadastro do material". Ela existe desde
                                 sempre em created_at; o que faltava era aparecer. -->
                            <el-input :value="dataCadastro" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Biblioteca" key="biblioteca_id">
                            <el-select v-model="dados.biblioteca_id" placeholder="Selecione" clearable
                                       filterable style="width:100%" @change="dados.secao_id = ''">
                                <el-option v-for="b in bibliotecas" :key="b.id" :label="b.nome" :value="b.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Seção" key="secao_id">
                            <el-select v-model="dados.secao_id" placeholder="Selecione" clearable
                                       filterable style="width:100%">
                                <el-option v-for="s in secoesDaBiblioteca" :key="s.id"
                                           :label="s.descricao" :value="s.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Outros autores (coautor, organizador, tradutor, ilustrador)"
                                      key="autores">
                            <el-select v-model="autoresSelecionados" multiple filterable
                                       placeholder="Selecione os demais autores" style="width:100%">
                                <el-option v-for="a in cat.autor" :key="a.id"
                                           :label="a.nome_apresentacao || a.nome" :value="a.id"></el-option>
                            </el-select>
                            <small class="u-text-muted">
                                A busca por termo livre encontra o material por qualquer um destes nomes.
                            </small>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Palavras-chave" prop="palavras_chave" key="palavras_chave">
                            <el-input v-model="dados.palavras_chave" maxlength="500"
                                      placeholder="Separe por vírgula"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Prefácio" prop="prefacio" key="prefacio">
                            <el-input type="textarea" :rows="3" v-model="dados.prefacio"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Sinopse / descrição" prop="sinopse" key="sinopse">
                            <el-input type="textarea" :rows="4" v-model="dados.sinopse" maxlength="2000" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-livro" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>

<script>
import InputImage from '@/shared/input-image/input-image.vue';

export default {
    props: ['paramId'],
    components: { 'input-image': InputImage },
    data: () => ({
        editLivro: false,
        capaFile: '',
        capaUrl: '',
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            id: '',
            instituicao_id: '',
            titulo: '',
            autor: '',
            editora: '',
            ano_publicacao: '',
            isbn: '',
            edicao: '',
            categoria: '',
            tipo: '',
            cdd: '',
            numero_tombo: '',
            quantidade_exemplares: 0,
            localizacao: '',
            idioma: '',
            numero_paginas: '',
            sinopse: '',
            capa_path: '',

            // BLOCO X — catalogação (item 9). Todos opcionais.
            autor_id: '',
            editora_id: '',
            idioma_id: '',
            assunto_id: '',
            colecao_id: '',
            classificacao_id: '',
            cutter_id: '',
            biblioteca_id: '',
            secao_id: '',
            volume: '',
            palavras_chave: '',
            prefacio: '',
            created_at: ''
        },

        // Catálogos de apoio, carregados uma vez.
        cat: { autor: [], editora: [], idioma: [], assunto: [], colecao: [], classificacao: [], cutter: [] },
        bibliotecas: [],
        secoes: [],
        tiposMaterial: [],
        classificacaoPadrao: '',
        tipoLegado: '',
        autoresSelecionados: []
    }),
    computed: {
        /** Item 9 — "data de cadastro do material". Vem de created_at; só faltava aparecer. */
        dataCadastro(){
            if(!this.dados.created_at) return '—';
            return this.$moment(this.dados.created_at).format('DD/MM/YYYY HH:mm');
        },

        /**
         * A classificação escolhida pela rede vem primeiro; as outras continuam disponíveis,
         * porque mudar a escolha não pode esconder o que já foi catalogado.
         */
        classificacoesOrdenadas(){
            const p = this.classificacaoPadrao;
            const lista = (this.cat.classificacao || []).slice();
            if(!p) return lista;
            return lista.sort((a, b) => {
                if(a.tipo === p && b.tipo !== p) return -1;
                if(b.tipo === p && a.tipo !== p) return 1;
                return 0;
            });
        },

        secoesDaBiblioteca(){
            if(!this.dados.biblioteca_id) return [];
            return this.secoes.filter(s => String(s.biblioteca_id) === String(this.dados.biblioteca_id));
        },

        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        this.carregarCatalogos();
        this.restaurarInstituicaoDoQuery();
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods:{
        /**
         * Carrega os cadastros do Bloco X que alimentam as seleções. Uma chamada por catálogo;
         * falha em um não derruba os outros — o formulário continua utilizável com texto.
         */
        carregarCatalogos(){
            const base = this.$store.state.config.baseUrlApi;
            const h = this.$store.getters.getHeaderAuth;

            ['autor','editora','idioma','assunto','colecao','classificacao','cutter'].forEach(tipo => {
                this.$axios.post(`${base}/api/biblioteca/catalogo/${tipo}/getAllPaginate`,
                                 { per_page: 200, situacao: 1 }, h)
                    .then(r => {
                        if(!r.data || r.data.erro) return;
                        this.$set(this.cat, tipo, r.data.data || []);
                    }).catch(() => {});
            });

            this.$axios.get(`${base}/api/biblioteca/catalogo/listas`, h)
                .then(r => {
                    if(!r.data || r.data.erro) return;
                    this.tiposMaterial = r.data.tipos_material || [];
                    this.classificacaoPadrao = r.data.classificacao_padrao || '';
                }).catch(() => {});

            this.$axios.post(`${base}/api/biblioteca/unidade/getAllPaginate`, { per_page: 200 }, h)
                .then(r => { this.bibliotecas = (r.data && !r.data.erro) ? (r.data.data || []) : []; })
                .catch(() => {});

            this.$axios.post(`${base}/api/biblioteca/secao/getAllPaginate`, { per_page: 200 }, h)
                .then(r => { this.secoes = (r.data && !r.data.erro) ? (r.data.data || []) : []; })
                .catch(() => {});
        },

        /**
         * Depois de carregar um material existente: descobre se o tipo dele é um valor antigo,
         * fora da lista oficial do item 11, e monta a lista de coautores.
         */
        prepararCatalogacaoCarregada(){
            const oficiais = (this.tiposMaterial || []).map(t => t.valor);

            this.tipoLegado = (this.dados.tipo && oficiais.length && oficiais.indexOf(this.dados.tipo) === -1)
                ? this.dados.tipo : '';

            // Coautoria: o autor principal fica no campo próprio, os demais na lista.
            const vinculados = this.dados.autores || [];
            this.autoresSelecionados = vinculados
                .filter(a => String(a.id) !== String(this.dados.autor_id))
                .map(a => a.id);
        },

        restaurarInstituicaoDoQuery(){
            const qId = this.$route.query.instituicao_id;
            if(!qId) return;
            const atual = this.$store.state.config.instituicao;
            if(atual && atual.id && String(atual.id) === String(qId)) return;
            const lista = this.$store.state.instituicoes || [];
            const fromList = Array.isArray(lista)
                ? lista.find(x => x && String(x.id) === String(qId))
                : (lista[qId] || null);
            const inst = fromList || { id: qId, nome: '' };
            this.$store.commit('setInstituicao', inst);
        },
        getLivroById(id){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
                this.dados = JSON.parse(JSON.stringify(response.data));
                if(this.dados.capa_path){
                    this.capaUrl = `${this.$store.state.config.baseUrlApi}/storage/` + this.dados.capa_path;
                }

                // As listas podem ainda estar carregando; roda de novo quando chegarem.
                this.prepararCatalogacaoCarregada();
                this.$nextTick(() => this.prepararCatalogacaoCarregada());
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitLivro(){
            document.getElementById("btn-livro").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
                window.eventBus.$emit('loading', true);

                this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;

                /*
                 * Coautoria (itens 9, 10 e 20). O autor principal entra primeiro, com papel
                 * `autor`; os demais vêm da seleção múltipla como `coautor`. O backend
                 * substitui o conjunto — mas só depois de validar todos.
                 */
                const autores = [];

                if(this.dados.autor_id){
                    autores.push({ autor_id: this.dados.autor_id, papel: 'autor', ordem: 1 });
                }

                (this.autoresSelecionados || []).forEach((id, i) => {
                    if(String(id) === String(this.dados.autor_id)) return;
                    autores.push({ autor_id: id, papel: 'coautor', ordem: autores.length + 1 });
                });

                this.dados.autores = autores;

                const trataErro = (response) => {
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível salvar o livro.');
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return true;
                    }
                    return false;
                };

                if(this.editLivro){
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        this.uploadCapaIfNeeded(this.dados.id).then(() => {
                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitLivro');
                        });
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }else{
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/store`, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        const novoId = response.data && response.data.id ? response.data.id : null;
                        this.uploadCapaIfNeeded(novoId).then(() => {
                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitLivro');
                        });
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        uploadCapaIfNeeded(livroId){
            if(!this.capaFile || !livroId){
                return Promise.resolve();
            }
            const fd = new FormData();
            fd.append('capa', this.capaFile);
            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/uploadCapa/` + livroId,
                fd,
                this.$store.getters.getHeaderFileAuth
            );
        },
        onCapaErro(msg){
            if(msg){
                window.eventBus.$emit('alert', {msg, type: 'warning'});
            }
        },
        onCapaDelete(){
            this.capaFile = '';
            this.capaUrl = '';
        },
        formatData(field){
            if(!this.dados[field]) return false;
            this.dados[field] = this.dados[field].toUpperCase();
            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if(value){
                    this.getLivroById(value);
                    this.editLivro = true;
                }
            }
        }
    }
}
</script>
